jQuery(document).ready(function ($) {
  var ajaxURL = ajax_object.ajax_url;
  function isSpanishLanguage() {
    return window.location.href.includes('/es/');
  }
  const occasionSlider = new Swiper('.occasion-swiper', {
    // Optional parameters
    // slidesPerView: 2.3,
    // spaceBetween: 10,
    loop: true,
    centeredSlides: true,
    speed: 1000,
    // Navigation arrows
    navigation: {
      nextEl: '.next-occ',
      prevEl: '.prev-occ',
    },
      breakpoints: {
        300: {
          slidesPerView: 1.2,
          spaceBetween: 4,
        },
        600: {
          slidesPerView: 1.3,
          spaceBetween: 6,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 6,
        },
        991: {
          slidesPerView: 1.5,
          spaceBetween: 6,
        },
        1200: {
          slidesPerView: 1.9,
          spaceBetween: 6,
        },
        1300: {
          slidesPerView: 2.3,
          spaceBetween: 10,
        },
      },
  });
  const fanFavSlider = new Swiper('.fan-fav-swiper', {
    // Optional parameters
    loop: true,
    speed: 1000,
    // Navigation arrows
    navigation: {
      nextEl: '.next-fav',
      prevEl: '.prev-fav',
    },
    breakpoints: {
      300: {
        slidesPerView: 1.1,
        spaceBetween: 0,
      },
      600: {
        slidesPerView: 1.7,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 0,
      },
      845: {
        slidesPerView: 2.5,
        spaceBetween: 0,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 16,
        // loop: false,
        // centeredSlides: false,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 25,
        centeredSlides: true,
      },
    },
  });
  const relatedRecipes = new Swiper('.related-recipe-carousel', {
    // Optional parameters
    loop: true,
    speed: 1000,
    // Navigation arrows
    navigation: {
      nextEl: '.next-recipe',
      prevEl: '.prev-recipe',
    },
    breakpoints: {
      300: {
        slidesPerView: 1.1,
        spaceBetween: 0,
      },
      600: {
        slidesPerView: 1.7,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 0,
      },
      845: {
        slidesPerView: 2.5,
        spaceBetween: 0,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 16,
        // loop: false,
        // centeredSlides: false,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
      },
    },
  });

  $('.recipe-swiper').each(function() {
      // This finds the closest '.recipe-carousel-wrapper' and searches within it for the navigation buttons
      var nextButton = $(this).closest('.recipe-carousel-wrapper').find('.next-fav');
      var prevButton = $(this).closest('.recipe-carousel-wrapper').find('.prev-fav');

      // Initialize Swiper
      var swiper = new Swiper(this, {
          loop: true,
          speed: 1000,
          navigation: {
              nextEl: nextButton[0], // Using [0] to pass the actual DOM element
              prevEl: prevButton[0], // Using [0] to pass the actual DOM element
          },
          breakpoints: {
              300: {
                  slidesPerView: 1.1,
                  spaceBetween: 0,
              },
              600: {
                  slidesPerView: 1.7,
                  spaceBetween: 0,
              },
              768: {
                  slidesPerView: 2.1,
                  spaceBetween: 0,
              },
              845: {
                  slidesPerView: 2.5,
                  spaceBetween: 0,
              },
              991: {
                  slidesPerView: 3,
                  spaceBetween: 16,
              },
              1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  // centeredSlides: true,
                  loop:true,
              },
          },
      });
  });

  // const recipeComponentCarousel = new Swiper('.recipe-swiper', {
  //   // Optional parameters
  //   loop: true,
  //   speed: 1000,
  //   // Navigation arrows
  //   navigation: {
  //     nextEl: '.next-fav',
  //     prevEl: '.prev-fav',
  //   },
  //   breakpoints: {
  //     300: {
  //       slidesPerView: 1.1,
  //       spaceBetween: 0,
  //     },
  //     600: {
  //       slidesPerView: 1.7,
  //       spaceBetween: 0,
  //     },
  //     768: {
  //       slidesPerView: 2.1,
  //       spaceBetween: 0,
  //     },
  //     845: {
  //       slidesPerView: 2.5,
  //       spaceBetween: 0,
  //     },
  //     991: {
  //       slidesPerView: 3,
  //       spaceBetween: 16,
  //       // loop: false,
  //       // centeredSlides: false,
  //     },
  //     1200: {
  //       slidesPerView: 3,
  //       spaceBetween: 30,
  //       centeredSlides: true,
  //     },
  //   },
  // });

  let page = 1;

  function fetchRecipes() {
    let search = $('.search-input').val();
    let mealType = $('[data-taxonomy="meal-type"]').val();
    let cuisine = $('[data-taxonomy="cuisine"]').val();
    let ingredient = $('[data-taxonomy="ingredients"]').val();
    $.ajax({
      url: ajaxURL,
      type: 'POST',
      data: {
        action: 'filter_recipes',
        search: search,
        meal_type: mealType,
        cuisine: cuisine,
        ingredient: ingredient,
        page: page
      },
      success: function (response) {
        let data = JSON.parse(response);  // Parse the JSON response
        if (isSpanishLanguage()) {
          $('#load-more').attr('disabled', false).text('Cargar más');
          $('#search-button').text('Filtrar');
        } else {
          $('#load-more').attr('disabled', false).text('Load More');
          $('#search-button').text('filter');
        }
        let newContent = $(data.html);  // Create a jQuery object from the HTML
        newContent.hide();  // Hide the content initially
        newContent.find('.make-recipe-link').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Hazlo');
          } else {
            $(this).text('Make It');
          }
        });
        newContent.find('.cooking-time-label').each(function () {
          if (isSpanishLanguage()) {
            $(this).html('Tiempo de <br>cocción');
          } else {
            $(this).text('cooking time');
          }
        });
        newContent.find('.cuisine-text-label').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('cocina');
          } else {
            $(this).text('cuisine');
          }
        });
        if (page === 1) {
          $('.recipe-filter-wrapper #jsRecipeRow').html(newContent);  // Replace old content
        } else {
          $('.recipe-filter-wrapper #jsRecipeRow').append(newContent);  // Append new content
        }
        newContent.fadeIn(1000);  // Fade in the new content over 1000 milliseconds (1 second)

        // Use the more_available flag to control the visibility of the load more button
        if (!data.more_available) {
          $('#load-more').hide();
        } else {
          $('#load-more').show();
        }
      }
    });
  }

  $('#search-button').on('click', function () {
    if (isSpanishLanguage()) {
      $(this).text('Cargando...')
    } else {
      $(this).text('Loading...')
    }
    page = 1; // Reset to first page on new search
    fetchRecipes();
  });

  $('#load-more').on('click', function () {
    // $(this).attr('disabled', true).text('Loading More');
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Cargando más');
    } else {
      $(this).attr('disabled', true).text('Loading More');
    }
    page++;
    fetchRecipes();
  });

  $('#clear-search').on('click', function () {
    $('.search-input').val('');
    $('select').each(function() {
      $(this).prop('selectedIndex', 0);
    });
    fetchRecipes();
    $(this).attr('disabled', true);
  });

  $('input, select').on('change input', function() {
    $('#clear-search').attr('disabled', false);
    $('#clear-research-search').attr('disabled', false);
  });

  function fetchResearch() {
    let search = $('.search-input').val();
    let researchType = $('[data-filter="type"]').val();
    let researchDate = $('[data-filter="date"]').val();
    let researchAuthor = $('[data-filter="author"]').val();
    $.ajax({
      url: ajaxURL,
      type: 'POST',
      data: {
        action: 'filter_research',
        search: search,
        researchType: researchType,
        researchDate: researchDate,
        researchAuthor: researchAuthor,
        page: page
      },
      success: function (response) {
        let data = JSON.parse(response);
        if (isSpanishLanguage()) {
          $('#load-more-research').attr('disabled', false).text('Cargar más');
          $('#search-research').text('Buscar Documentos');
        } else {
          $('#load-more-research').attr('disabled', false).text('Load More');
          $('#search-research').text('Search Documents');
        }
        let newContent = $(data.html);
        newContent.hide();
        newContent.find('.research-learn-more').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Aprende más');
          } else {
            $(this).text('Learn More');
          }
        });
        newContent.find('.date-published-translate').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Fecha de Publicación');
          } else {
            $(this).text('Date Published');
          }
        });
        newContent.find('.institution-translate').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Institución');
          } else {
            $(this).text('Institution');
          }
        });
        newContent.find('.research-author-translate').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Investigación/Autor');
          } else {
            $(this).text('Research/Author');
          }
        });
        if (page === 1) {
          $('.research-post-wrapper #jsResearchRow').html(newContent);
        } else {
          $('.research-post-wrapper #jsResearchRow').append(newContent);
        }
        newContent.fadeIn(1000);

        if (!data.more_available) {
          $('#load-more-research').hide();
        } else {
          $('#load-more-research').show();
        }
      }
    });
  }

  $('#search-research').on('click', function () {
    $(this).text('Searching...')
    if (isSpanishLanguage()) {
      $(this).text('Buscando...');
    } else {
      $(this).text('Searching...');
    }
    page = 1; // Reset to first page on new search
    fetchResearch();
  });
  $('#load-more-research').on('click', function () {
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Cargando más');
    } else {
      $(this).attr('disabled', true).text('Loading More');
    }
    page++;
    fetchResearch();
  });
  $('#clear-research-search').on('click', function () {
    $('.search-input').val('');
    $('select').each(function() {
      $(this).prop('selectedIndex', 0);
    });
    fetchResearch();
    $(this).attr('disabled', true);
  });

  // Fetch favorites and update display
  function fetchFavoritesAndUpdateDisplay() {
      var favorites = localStorage.getItem('favorites');
      favorites = favorites ? JSON.parse(favorites) : [];
      $.post(ajaxURL, {
          action: 'fetch_favorites',
          post_ids: favorites
      }, function(response) {
          $('#favorite-posts').html(response);
          updateFavoritesDisplay(); // Update after HTML insertion
      }).fail(function(error) {
          console.log('Error fetching favorites:', error);
      });
  }

  // Update the UI to reflect favorite status
  function updateFavoritesDisplay() {
      var favorites = localStorage.getItem('favorites');
      favorites = favorites ? JSON.parse(favorites) : [];
      $('.like-count span').text(favorites.length);

      $('.jsAddFavorite').each(function() {
          var postId = $(this).data('post-id');
          if (favorites.includes(postId)) {
            $(this).addClass('active-favorite');
          } else {
            $(this).removeClass('active-favorite');
          }
      });
  }

  // Event delegation for dynamically loaded content
  $(document).on('click', '.jsAddFavorite', function() {
      var postId = $(this).data('post-id');
      var favorites = localStorage.getItem('favorites');
      favorites = favorites ? JSON.parse(favorites) : [];

      if (favorites.includes(postId)) {
          favorites = favorites.filter(id => id !== postId); // Remove from favorites
      } else {
          favorites.push(postId); // Add to favorites
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));
      updateFavoritesDisplay(); // Update the count and button states
  });

  fetchFavoritesAndUpdateDisplay(); // Initial fetch and display




  function fetchBlogs() {
    let category = $('#tag-filter').val();
    $.ajax({
      url: ajaxURL,
      type: 'POST',
      data: {
        action: 'filter_blogs',
        category: category,
        page: page
      },
      success: function (response) {
        let data = JSON.parse(response);
        if (isSpanishLanguage()) {
          $('#load-more-blogs').attr('disabled', false).text('Cargar más');
          $('#filter-blogs').text('Filtrar');
        } else {
          $('#load-more-blogs').attr('disabled', false).text('Load More');
          $('#filter-blogs').text('Filter');
        }

        let newContent = $(data.html);
        newContent.hide();
        newContent.find('.learn-more-link').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Aprender más');
          } else {
            $(this).text('learn more');
          }
        });
        if (page === 1) {
          $('#jsBlogRow').html(newContent);
        } else {
          $('#jsBlogRow').append(newContent);
        }
        newContent.fadeIn(1000);
        if (!data.more_available) {
          $('#load-more-blogs').hide();
        } else {
          $('#load-more-blogs').show();
        }
      }
    });
  }

  $('#filter-blogs').on('click', function () {
    if (isSpanishLanguage()) {
      $(this).text('Filtrando...');
    } else {
      $(this).text('Filtering...');
    }
    page = 1; // Reset to first page on new search
    fetchBlogs();
  });

  $('#tag-filter').on('change input', function() {
    $('#clear-blogs').attr('disabled', false);
  });

  $('#load-more-blogs').on('click', function () {
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Cargando más');
    } else {
      $(this).attr('disabled', true).text('Loading More');
    }
    page++;
    fetchBlogs();
  });

  $('#clear-blogs').on('click', function () {
    $('#tag-filter').prop('selectedIndex', 0);
    fetchBlogs();
    $(this).attr('disabled', true);
  });


  var taxpage = ajax_object.current_page;
  var query_vars = ajax_object.query_vars;

  function fetchTaxPosts() {
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'load_more_tax',
        page: taxpage,
        query_vars: query_vars,
        posts_nonce: ajax_object.posts_nonce
      },
      success: function(response) {
        var data = JSON.parse(response);
        if (isSpanishLanguage()) {
          $('#load-more-taxonomy').attr('disabled', false).text('Cargar más');
        } else {
          $('#load-more-taxonomy').attr('disabled', false).text('Load More');
        }
        // $('#load-more-taxonomy').attr('disabled', false).text('Load More');
        var newContent = $(data.html);
        newContent.find('.make-recipe-link').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Hazlo');
          } else {
            $(this).text('Make It');
          }
        });
        newContent.find('.cooking-time-label').each(function () {
          if (isSpanishLanguage()) {
            $(this).html('Tiempo de <br>cocción');
          } else {
            $(this).text('cooking time');
          }
        });
        newContent.find('.cuisine-text-label').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('cocina');
          } else {
            $(this).text('cuisine');
          }
        });
        newContent.hide();
        $('#jsTaxonomyRow').append(newContent);
        newContent.fadeIn(1000);

        if (!data.more_available) {
          $('#load-more-taxonomy').hide();
        } else {
          $('#load-more-taxonomy').show();
        }
      },
      error: function(xhr, status, error) {
        console.log('Error fetching posts:', error);
        $('#load-more-taxonomy').attr('disabled', false).text('Load More');
      }
    });
  }

  $('#load-more-taxonomy').on('click', function () {
    // $(this).attr('disabled', true).text('Loading More');
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Cargando más');
    } else {
      $(this).attr('disabled', true).text('Loading More');
    }
    taxpage++;
    fetchTaxPosts();
  });


  $('#print-recipe').on('click', function () {
    printRecipe();
  });
  function printRecipe() {
    window.print();
  }



  $('#nav-toggle').on('click', function () {
    $(this).toggleClass('active');
    $('#mobile-menu').toggleClass('menu-open');
  });
  $('#mobile-menu .collapse').on('show.bs.collapse', function () {
    $('.collapse.show').each(function() {
      $(this).collapse('hide');
    });
  });


  let totalScore = 0;
  let currentQuestionIndex = 0;
  const questions = $('.quiz-question');
  const totalQuestions = questions.length;

  function showNextQuestion() {
    $(questions[currentQuestionIndex]).removeClass('active');
    currentQuestionIndex++;
    if (currentQuestionIndex < totalQuestions) {
      $(questions[currentQuestionIndex]).addClass('active');
    } else {
      showResult();
    }
  }

  function showResult() {
    $('.result').each(function() {
      const minScore = $(this).data('min-score');
      const maxScore = $(this).data('max-score');
      if (totalScore >= minScore && totalScore <= maxScore) {
        $(this).show();
      }
    });
  }

  function resetQuiz() {
    totalScore = 0;
    currentQuestionIndex = 0;
    $('.quiz-question').removeClass('active');
    $(questions[0]).addClass('active');
    $('.result').hide();
    $('input[type=radio]').prop('checked', false);
  }

  $('input[type=radio]').on('change', function() {
    totalScore += parseInt($(this).val());
    showNextQuestion();
  });

  $(document).on('click', '.jsResetQuiz', function() {
    resetQuiz();
  });



  function fetchImageLogos() {
    let search = $('.search-input').val();
    let category = $('[data-filter="images"]').val();
    let language = isSpanishLanguage() ? 'es' : 'en';
    $.ajax({
      url: ajaxURL,
      type: 'POST',
      data: {
        action: 'filter_logos',
        search: search,
        category: category,
        page: page,
        language: language
      },
      success: function (response) {
        let data = JSON.parse(response);
        // $('#load-more-logos').attr('disabled', false).text('Load More');
        if (isSpanishLanguage()) {
          $('#load-more-logos').attr('disabled', false).text('Cargar más');
          $('.jsSearchImageLogos').text('Buscar');
        } else {
          $('#load-more-logos').attr('disabled', false).text('Load More');
          $('.jsSearchImageLogos').text('Search');
        }

        $('.jsSearchImageLogos').attr('disabled', false);
        let newContent = $(data.html);
        newContent.find('.js-logo-img-btn').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Descargar');
          } else {
            $(this).text('Download');
          }
        });
        newContent.find('.js-load-more-logo-img').each(function () {
          if (isSpanishLanguage()) {
            $(this).text('Cargando más');
          } else {
            $(this).text('Load More');
          }
        });
        newContent.hide();
        if (page === 1) {
          $('.filterable-image-logo #jsImageRow').html(newContent);
        } else {
          $('.filterable-image-logo #jsImageRow').append(newContent);
        }
        newContent.fadeIn(1000);
        if (!data.more_available) {
          $('#load-more-logos').hide();
        } else {
          $('#load-more-logos').show();
        }
      }
    });
  }

  $('.jsSearchImageLogos').on('click', function () {
    // $(this).text('Filtering..')
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Filtrado...');
    } else {
      $(this).attr('disabled', true).text('Filtering...');
    }
    page = 1; // Reset to first page on new search
    fetchImageLogos();
  });
  $('#load-more-logos').on('click', function () {
    if (isSpanishLanguage()) {
      $(this).attr('disabled', true).text('Cargando más');
    } else {
      $(this).attr('disabled', true).text('Loading More');
    }
    page++;
    fetchImageLogos();
  });
  $('#clear-research-search').on('click', function () {
    $('.search-input').val('');
    $('select').each(function() {
      $(this).prop('selectedIndex', 0);
    });
    fetchResearch();
    $(this).attr('disabled', true);
  });


});